import { useState } from 'react';
import { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router';
import styled from 'styled-components';
import useDidMountEffect from '../../utils/useDidMountEffect';
import PAlert from '../../common/PAlert';
import { useDispatch } from 'react-redux';
import { setAlert } from '../../../redux/actions';

const PromoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    flex-shrink: 0;
    flex-grow: 1;
`;

const Trial = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const history = useHistory();

    const [busy, setBusy] = useState(false);
    const [promo, setPromo] = useState({});
    const [promoCode, setPromoCode] = useState('');
    const [isFreeTrial, setIsFreeTrial] = useState(false);

    const [alertBody, setAlertBody] = useState('');
    const [show, setShow] = useState(false);

    useEffect(() => {
        let mounted = true;

        setPromoCode(params.promoUrl);

        return () => {
            mounted = false;
        };
    }, []);

    useDidMountEffect(() => {
        let mounted = true;
        if (promoCode) {
            getPromoDetails();
        } else {
            history.push('/');
        }

        return () => {
            mounted = false;
        };
    }, [promoCode]);

    const getPromoDetails = async () => {
        setBusy(true);
        await axios.get('/api/promotions/url', {
            params: {
                link_url: promoCode
            }
        })
            .then((response) => {
                setBusy(false);

                const data = response.data;

                if (data.status) {
                    setIsFreeTrial(data.is_free_trial);

                    localStorage.setItem('promo_url', JSON.stringify(response.data.promo));
                    history.push(`/${response.data.promo.user.login}`, {
                        discount_data: data.promo.link_url ? {
                            link_url: data.promo.link_url,
                            link_price: data.promo.link_price
                        } : null
                    });
                } else {
                    dispatch(setAlert({
                        show: true,
                        type: 'error',
                        body: 'The link is not valid'
                    }));
                    history.push('/privamodelspreview');
                }
            })
            .catch(error => {
                setBusy(false);
                console.error({ error });
                if (error.response && error.response.status === 404) {
                    localStorage.removeItem('promo_url');
                    setAlertBody('This link is no longer available');
                    setShow(true);
                }
            });
    };

    const handleAlertClose = () => {
        const isLoggedIn = localStorage.getItem('loggedin_user');

        if (!isLoggedIn) {
            history.push('/login');
        }
        localStorage.removeItem('promo_url');
        history.push(`/privamodelspreview`);

        setShow(false);
    };

    return <div className='container d-flex'>
        {
            busy && <PromoContainer>
                <div>
                    <Spinner size='md' variant='primary' animation='border' />
                </div>
                <div>
                    Checking promo information
                </div>
            </PromoContainer>
        }

        {
            !busy && promo && Object.keys(promo).length > 0 && !promo.status && <PromoContainer>
                <div className='alert alert-danger text-center px-5 py-1'>
                    Sorry, this link has already expired
                </div>
            </PromoContainer>
        }
        {
            show
                ? <PAlert
                    body={alertBody}
                    show={show}
                    setShow={setShow}
                    onClose={handleAlertClose}
                />
                : null
        }
    </div>;
};

export default Trial;